// tienda/CoverageList.jsx

import React, { useMemo, useState } from "react";
import { Search, X } from "lucide-react";
import { brand, WA_HREF } from "../shared/brand";

const ALL_DISTRICTS = [
  "Cercado de Lima",
  "Ate",
  "Barranco",
  "Breña",
  "Carabayllo",
  "Chaclacayo",
  "Chorrillos",
  "Cieneguilla",
  "Comas",
  "El Agustino",
  "Independencia",
  "Jesús María",
  "La Molina",
  "La Victoria",
  "Lince",
  "Los Olivos",
  "Lurigancho",
  "Lurín",
  "Magdalena del Mar",
  "Miraflores",
  "Pachacamac",
  "Pueblo Libre",
  "Puente Piedra",
  "Pucusana",
  "Punta Hermosa",
  "Punta Negra",
  "Rimac",
  "San Bartolo",
  "San Borja",
  "San Isidro",
  "San Juan de Lurigancho",
  "San Juan de Miraflores",
  "San Luis",
  "San Martin de Porres",
  "San Miguel",
  "Santa Anita",
  "Santa María del Mar",
  "Santa Rosa",
  "Santiago de Surco",
  "Surquillo",
  "Villa El Salvador",
  "Villa Maria del Triunfo",
  "Ancón",
  "Callao",
  "Bellavista",
  "Carmen de La Legua Reynoso",
  "La Perla",
  "La Punta",
  "Mi Perú",
  "Ventanilla",
].sort((a, b) => a.localeCompare(b, "es"));

export function CoverageList() {
  const [q, setQ] = useState("");

  const filtered = useMemo(() => {
    const term = q.trim().toLowerCase();
    return term ? ALL_DISTRICTS.filter(d => d.toLowerCase().includes(term)) : ALL_DISTRICTS;
  }, [q]);

  return (
    <div className="rounded-2xl border bg-white p-5 shadow-sm lg:self-start" style={{ borderColor: brand.line }}>
      <div className="mb-3 flex items-center justify-between gap-3">
        <div>
          <h3 className="text-base font-black" style={{ color: brand.ink }}>Distritos same-day</h3>
          <p className="text-xs" style={{ color: brand.muted }}>
            Lima y Callao para entregas el mismo día.
          </p>
        </div>
        <span className="rounded-full px-3 py-1 text-xs font-black text-white" style={{ background: brand.accentGreen }}>
          {ALL_DISTRICTS.length}
        </span>
      </div>

      <div className="mb-3 flex items-center gap-2 rounded-xl border bg-white px-3 py-2" style={{ borderColor: brand.line }}>
        <Search className="size-4 shrink-0" style={{ color: brand.muted }} />
        <input
          value={q}
          onChange={e => setQ(e.target.value)}
          placeholder="Buscar distrito..."
          className="w-full bg-transparent text-sm outline-none placeholder:text-slate-400"
        />
        {q && (
          <button type="button" onClick={() => setQ("")} aria-label="Limpiar búsqueda">
            <X className="size-4 hover:opacity-70" style={{ color: brand.muted }} />
          </button>
        )}
      </div>

      {filtered.length === 0 ? (
        <p className="text-sm" style={{ color: brand.muted }}>
          Distrito no encontrado.{" "}
          <a href={WA_HREF} target="_blank" rel="noopener noreferrer" className="font-black hover:underline" style={{ color: brand.primary }}>
            Contáctanos
          </a>
        </p>
      ) : (
        <ul className="grid max-h-72 grid-cols-1 gap-2 overflow-y-auto pr-1 sm:grid-cols-2 lg:max-h-80">
          {filtered.map(district => (
            <li
              key={district}
              className="flex min-h-10 items-center gap-2 rounded-xl border px-3 py-1.5 text-xs font-semibold"
              style={{ borderColor: brand.line, color: brand.muted, background: brand.bg }}
            >
              <span className="size-2 shrink-0 rounded-full" style={{ background: brand.accentGreen }} />
              <span className="truncate">{district}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
